import { useState } from "react";
import prodotti_fetch from "../fetch/prodotti_fetch";
import create_autocompleteWithService from "../riutilizabili/create_autocompleteWithService";
import PulsantiFiltra from "../riutilizabili/PulsantiFiltra";


export default function RicercaOrdini({
    values , 
    onChange , 
    filtra = false ,
    errors={} , 
    azzeraFiltra 
}) {

    const assMetPag = ({item , value})=> {
        if (item) {
            onChange('prodottoId' , item.id)
            onChange('descrizione' , item.descrizione)
            onChange('rifInterno' , item.rifInterno)
        }else {
            onChange('prodottoId' , null)
        }
    }

    const ProdottiAutocomplite = create_autocompleteWithService({
        freeinput: true,
        service: (myValue, serviceValues) => prodotti_fetch.get({
            nomeCodice: myValue,
            ...serviceValues,
        }),
        itemCompare: (item, inputValue) => (item.descrizione+ ' '+item.rifInterno)?.toLowerCase().indexOf((inputValue || "")?.toLowerCase()) !== -1,
        itemToLi: item => item.descrizione+' - '+ item.rifInterno+ ''+ (item.infoFornitore !== null ? ' - '+item.infoFornitore.nome : ' '),
        itemToString: item => item.descrizione+' - '+ item.rifInterno,
        itemFind: (value, items) => items.reduce((acc, curr) => acc || (curr?.nome.toLowerCase() === value?.toLowerCase() ? curr : null), null),
        label: 'Selezione articolo',
        placeholder: 'Selezione rapida : inserisci codice interno o descrizione articolo',
        value : !!values?.descrizione ? values?.descrizione  +' - '+ values?.rifInterno : '',
        onChange : assMetPag ,
        className :' w-100 ' ,
    });

    return(
        <div className=" col-7">
            <ProdottiAutocomplite />
            <div className="col-7 ms-2" >
                
                {filtra &&
                <PulsantiFiltra
                    filtra={filtra}
                    azzera={azzeraFiltra}
                />}
            </div>
        </div>
    )
}